module.exports = __webpack_public_path__ + "img/S2SLogo.a3a838ee.png";